type DeliveryAddressForReprice = {
  addressLine1?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
};

const normalizeAddressPart = (value?: string | null) => value?.trim().toLowerCase() ?? '';

const deliveryAddressesMatch = (
  selectedAddress?: DeliveryAddressForReprice | null,
  serverDropoff?: DeliveryAddressForReprice | null
) => {
  if (!selectedAddress || !serverDropoff) {
    return false;
  }

  return (
    normalizeAddressPart(selectedAddress.addressLine1) ===
      normalizeAddressPart(serverDropoff.addressLine1) &&
    normalizeAddressPart(selectedAddress.city) === normalizeAddressPart(serverDropoff.city) &&
    normalizeAddressPart(selectedAddress.state) === normalizeAddressPart(serverDropoff.state) &&
    normalizeAddressPart(selectedAddress.zip) === normalizeAddressPart(serverDropoff.zip)
  );
};

export const isDeliveryQuoteOrAddressStale = ({
  quoteId,
  serverOrderDeliveryQuoteId,
  deliveryAddress,
  serverOrderDropoff,
}: {
  quoteId?: string | null;
  serverOrderDeliveryQuoteId?: string | null;
  deliveryAddress?: DeliveryAddressForReprice | null;
  serverOrderDropoff?: DeliveryAddressForReprice | null;
}) => {
  if (quoteId && serverOrderDeliveryQuoteId) {
    return quoteId !== serverOrderDeliveryQuoteId;
  }

  return !deliveryAddressesMatch(deliveryAddress, serverOrderDropoff);
};
